import { render } from "./ShoprenterSettingsView.vue?vue&type=template&id=7c476552"
import script from "./ShoprenterSettingsView.vue?vue&type=script&lang=js"
export * from "./ShoprenterSettingsView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/ui/views/ShoprenterSettingsView.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7c476552"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7c476552', __exports__)) {
    api.reload('7c476552', __exports__)
  }
  
  module.hot.accept("./ShoprenterSettingsView.vue?vue&type=template&id=7c476552", () => {
    api.rerender('7c476552', render)
  })

}


export default __exports__